import { render } from "./HelpModal.vue?vue&type=template&id=511e3d56&scoped=true&ts=true"
import script from "./HelpModal.vue?vue&type=script&lang=ts"
export * from "./HelpModal.vue?vue&type=script&lang=ts"

import "./HelpModal.vue?vue&type=style&index=0&id=511e3d56&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511e3d56"]])

export default __exports__